
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ca7si", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $6xdDU = parcelRequire("6xdDU");


var $bVAxT = parcelRequire("bVAxT");


var $jmjWc = parcelRequire("jmjWc");


const $33d1c28d7fe6dfd8$export$aacd7876c1515a79 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pb5BG",
    name: "RestrictionsDialogLoader",
    loader: async ()=>(await (parcelRequire("iGr8A"))).RestrictionsDialog
});






const $0fa5aab78d012116$export$e84541173fbfa3aa = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YDzS8",
    name: "RestrictionsUpsellDialogLoader",
    loader: async ()=>(await (parcelRequire("9jK2j"))).RestrictionsUpsellDialog
});












var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $ckmNl = parcelRequire("ckmNl");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");

const $38669da89d4c39dc$export$22cec9cb36430bce = (0, $3u0dr.isReactCompilerActiveV2)() ? function IsUpsellQueryComponent(props) {
    const $ = (0, $frIzR.c)(7);
    const contentId = (0, $ckmNl.useContentId)(props.contentId);
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (contentId) {
        if (loading) return null;
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) return null;
            else {
                let t0;
                if ($[0] !== error) {
                    t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    $[0] = error;
                    $[1] = t0;
                } else t0 = $[1];
                return t0;
            }
        }
        const hasRestrictions = Boolean(restrictions?.hasRestrictions);
        const hasInheritedRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        const isContentRestricted = hasRestrictions || hasInheritedRestrictions;
        const t0 = edition === "FREE" && !isContentRestricted;
        let t1;
        if ($[2] !== props.children || $[3] !== t0) {
            t1 = props.children({
                isUpsell: t0
            });
            $[2] = props.children;
            $[3] = t0;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    } else {
        let t0;
        if ($[5] !== props.children) {
            t0 = props.children({
                isUpsell: false
            });
            $[5] = props.children;
            $[6] = t0;
        } else t0 = $[6];
        return t0;
    }
} : function IsUpsellQueryComponent(props) {
    const contentId = (0, $ckmNl.useContentId)(props.contentId);
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (contentId) {
        if (loading) return null;
        if (error) {
            // For legacy purposes, we don't render `children` when there is an
            // `error`.
            if ((0, $1uFM6.isUnauthorizedError)(error)) // `edition` (e.g. anonymous access is not permitted) and/or
            // `content` is not permitted to the current user and in either case
            // we know we don't want to do an upsell related to Restrictions
            // dialog. So here an unauthorized error is an expected error.
            // The error is marked as expected inside PageRestrictionsContextProvider.
            return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        }
        const hasRestrictions = Boolean(restrictions?.hasRestrictions);
        const hasInheritedRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        const isContentRestricted = hasRestrictions || hasInheritedRestrictions;
        return props.children({
            isUpsell: edition === 'FREE' && !isContentRestricted
        });
    } else return props.children({
        isUpsell: false
    });
};


const $78dd331c86d6bb99$export$41c7a5bde62dd6f6 = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsDialogMountPoint(t0) {
    const $ = (0, $frIzR.c)(3);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1
        }, (dialogStateContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38669da89d4c39dc$export$22cec9cb36430bce), {
                contentId: contentId
            }, (t3)=>{
                const { isUpsell: isUpsell } = t3;
                let dialog;
                if (dialogStateContainer.getIsOpen()) {
                    const onClose = (callback)=>{
                        dialogStateContainer.setIsOpen(false, null, callback);
                    };
                    dialog = isUpsell ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0fa5aab78d012116$export$e84541173fbfa3aa), {
                        onClose: onClose
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33d1c28d7fe6dfd8$export$aacd7876c1515a79), {
                        contentId: dialogStateContainer.getContentId(),
                        hideSpinner: ()=>dialogStateContainer.setHideRestrictionsButtonSpinner(),
                        onClose: onClose
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, dialog);
            }));
        $[1] = contentId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function RestrictionsDialogMountPoint({ contentId: contentId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38669da89d4c39dc$export$22cec9cb36430bce), {
            contentId: contentId
        }, ({ isUpsell: isUpsell })=>{
            let dialog;
            if (dialogStateContainer.getIsOpen()) {
                const onClose = (callback)=>{
                    dialogStateContainer.setIsOpen(false, null, callback);
                };
                dialog = isUpsell ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0fa5aab78d012116$export$e84541173fbfa3aa), {
                    onClose: onClose
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33d1c28d7fe6dfd8$export$aacd7876c1515a79), {
                    contentId: dialogStateContainer.getContentId(),
                    hideSpinner: ()=>dialogStateContainer.setHideRestrictionsButtonSpinner(),
                    onClose: onClose
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, dialog);
        }));
};
module.exports["RestrictionsDialogMountPoint"] = $78dd331c86d6bb99$export$41c7a5bde62dd6f6;

});

parcelRegister("iGr8A", function(module, exports) {

let $d9a1332cd900113a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d9a1332cd900113a$var$load("eOZfH"),
    $d9a1332cd900113a$var$load("26Bzu"),
    $d9a1332cd900113a$var$load("dHMdi"),
    $d9a1332cd900113a$var$load("lId0W"),
    $d9a1332cd900113a$var$load("fSobj"),
    $d9a1332cd900113a$var$load("74u2y"),
    $d9a1332cd900113a$var$load("4izLy"),
    $d9a1332cd900113a$var$load("kC6GH"),
    $d9a1332cd900113a$var$load("a8Jk0"),
    $d9a1332cd900113a$var$load("6alNH"),
    $d9a1332cd900113a$var$load("c831e"),
    $d9a1332cd900113a$var$load("6wr18"),
    $d9a1332cd900113a$var$load("kjZZD"),
    $d9a1332cd900113a$var$load("h4Nf7"),
    $d9a1332cd900113a$var$load("cEqm7"),
    $d9a1332cd900113a$var$load("6XCf4"),
    $d9a1332cd900113a$var$load("7EorR"),
    $d9a1332cd900113a$var$load("Wowvf"),
    $d9a1332cd900113a$var$load("5pvpJ"),
    $d9a1332cd900113a$var$load("hhss7"),
    $d9a1332cd900113a$var$load("ffEVr"),
    $d9a1332cd900113a$var$load("1qlDN"),
    $d9a1332cd900113a$var$load("1yVM6"),
    $d9a1332cd900113a$var$load("inQqk")
]).then(()=>parcelRequire('eehrp'));

});

parcelRegister("9jK2j", function(module, exports) {

let $6c899943823091f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c899943823091f4$var$load("cEqm7"),
    $6c899943823091f4$var$load("6XCf4"),
    $6c899943823091f4$var$load("5pvpJ"),
    $6c899943823091f4$var$load("1qlDN"),
    $6c899943823091f4$var$load("1yVM6"),
    $6c899943823091f4$var$load("2VACG")
]).then(()=>parcelRequire('gYlZZ'));

});


//# sourceMappingURL=RestrictionsDialogMountPoint.45955d15.js.map
